import React from "react";
import ContentLoader from "react-content-loader";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";

export const SkeletonComplementaryProducts = () => {
    const { isDesktop, isMobile } = useViewport();

    if (isMobile) {
        return (
            <ContentLoader
                speed={2}
                width={300}
                height={400}
                viewBox="0 0 375 430"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
            >
                <rect x="10" y="85" rx="2" ry="2" width="260" height="230" />
                <rect x="10" y="327" rx="2" ry="2" width="260" height="90" />
                <rect x="294" y="326" rx="2" ry="2" width="260" height="90" />
                <rect x="294" y="85" rx="2" ry="2" width="260" height="230" />
                <rect x="9" y="23" rx="0" ry="0" width="303" height="28" />
            </ContentLoader>
        );
    }

    if (isDesktop) {
        return (
            <ContentLoader
                speed={2}
                width={1000}
                height={430}
                viewBox="0 0 1000 430"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
            >
                <rect x="9" y="23" rx="0" ry="0" width="303" height="28" />
                <rect x="10" y="85" rx="2" ry="2" width="260" height="230" />
                <rect x="10" y="327" rx="2" ry="2" width="260" height="90" />
                <rect x="295" y="327" rx="2" ry="2" width="260" height="90" />
                <rect x="295" y="85" rx="2" ry="2" width="260" height="230" />
                <rect x="582" y="85" rx="2" ry="2" width="260" height="230" />
                <rect x="582" y="327" rx="2" ry="2" width="260" height="90" />
                <rect x="869" y="85" rx="2" ry="2" width="260" height="230" />
                <rect x="869" y="327" rx="2" ry="2" width="260" height="90" />
            </ContentLoader>
        );
    }

    return (
        <ContentLoader
            speed={2}
            width={700}
            height={430}
            viewBox="0 0 700 430"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            <rect x="9" y="23" rx="0" ry="0" width="303" height="28" />
            <rect x="10" y="85" rx="2" ry="2" width="260" height="230" />
            <rect x="10" y="327" rx="2" ry="2" width="260" height="90" />
            <rect x="295" y="327" rx="2" ry="2" width="260" height="90" />
            <rect x="295" y="85" rx="2" ry="2" width="260" height="230" />
            <rect x="582" y="85" rx="2" ry="2" width="260" height="230" />
            <rect x="582" y="327" rx="2" ry="2" width="260" height="90" />
        </ContentLoader>
    );
};

export const SkeletonTimeSlots = () => {
    return (
        <ContentLoader
            speed={2}
            width={375}
            height={420}
            viewBox="40 -20 375 420"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            <rect x="40" y="30" rx="5" ry="5" width="325" height="50" />
            <rect x="40" y="100" rx="5" ry="5" width="325" height="50" />
            <rect x="40" y="170" rx="5" ry="5" width="325" height="50" />
            <rect x="40" y="240" rx="5" ry="5" width="325" height="50" />
            <rect x="40" y="310" rx="5" ry="5" width="325" height="50" />
        </ContentLoader>
    );
};

export const SkeletonDressings = () => {
    const { isDesktop } = useViewport();
    if (isDesktop) {
        return (
            <ContentLoader
                speed={2}
                width={500}
                height={420}
                viewBox="0 0 500 420"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
            >
                <rect x="16" y="0" rx="5" ry="5" width="470" height="50" />
                <rect x="16" y="58" rx="5" ry="5" width="470" height="50" />
                <rect x="16" y="116" rx="5" ry="5" width="470" height="50" />
                <rect x="16" y="174" rx="5" ry="5" width="470" height="50" />
                <rect x="16" y="232" rx="5" ry="5" width="470" height="50" />
                <rect x="16" y="290" rx="5" ry="5" width="470" height="50" />
                <rect x="16" y="348" rx="5" ry="5" width="470" height="50" />
            </ContentLoader>
        );
    }

    return (
        <ContentLoader
            speed={2}
            width={320}
            height={300}
            viewBox="0 0 320 300"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            <rect x="16" y="0" rx="5" ry="5" width="300" height="50" />
            <rect x="16" y="58" rx="5" ry="5" width="300" height="50" />
            <rect x="16" y="116" rx="5" ry="5" width="300" height="50" />
            <rect x="16" y="174" rx="5" ry="5" width="300" height="50" />
            <rect x="16" y="232" rx="5" ry="5" width="300" height="50" />
            <rect x="16" y="290" rx="5" ry="5" width="300" height="50" />
        </ContentLoader>
    );
};

export const SkeletonFastCheckout = () => {
    return (
        <ContentLoader
            speed={2}
            width={400}
            height={660}
            viewBox="0 0 400 660"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            <rect x="16" y="32" rx="6" ry="6" width="161" height="26" />
            <rect x="16" y="58" rx="6" ry="6" width="185" height="20" />
            <rect x="0" y="90" rx="6" ry="6" width="400" height="1" />
            <rect x="16" y="107" rx="6" ry="6" width="148" height="20" />
            <rect x="168" y="107" rx="6" ry="6" width="121" height="23" />
            <rect x="168" y="130" rx="6" ry="6" width="90" height="23" />
            <rect x="168" y="153" rx="6" ry="6" width="97" height="23" />
            <rect x="16" y="188" rx="6" ry="6" width="343" height="1" />
            <rect x="16" y="201" rx="6" ry="6" width="148" height="20" />
            <rect x="168" y="201" rx="6" ry="6" width="191" height="46" />
            <rect x="16" y="259" rx="6" ry="6" width="343" height="1" />
            <rect x="16" y="272" rx="6" ry="6" width="148" height="20" />
            <rect x="168" y="272" rx="6" ry="6" width="51" height="23" />
            <rect x="16" y="307" rx="6" ry="6" width="343" height="1" />
            <rect x="16" y="307" rx="6" ry="6" width="343" height="1" />
            <rect x="16" y="320" rx="6" ry="6" width="148" height="20" />
            <rect x="168" y="343" rx="6" ry="6" width="191" height="22" />
            <rect x="168" y="320" rx="6" ry="6" width="191" height="23" />
            <rect
                x="177.33"
                y="380.45"
                rx="6"
                ry="6"
                width="13.22"
                height="13.22"
            />
            <rect x="200" y="377" rx="6" ry="6" width="129" height="20" />
            <rect x="16" y="413" rx="6" ry="6" width="343" height="1" />
            <rect x="16" y="426" rx="6" ry="6" width="148" height="20" />
            <rect x="168" y="426" rx="6" ry="6" width="167" height="69" />
            <rect x="16" y="507" rx="6" ry="6" width="343" height="1" />
            <rect x="32" y="545.5" rx="6" ry="6" width="224" height="21" />
            <rect x="284" y="545.5" rx="6" ry="6" width="51" height="20" />
            <rect x="112.5" y="605.5" rx="6" ry="6" width="150" height="20" />
        </ContentLoader>
    );
};
